export class AigleVersion {

  private versionString = "0.44";

  get version(): string {
    return "ver " + this.versionString;
  }

}